module.exports = __webpack_public_path__ + "img/wedding-15.34c35dec.jpg";